<template>
  <div>
    <b-modal id="user-tenants-modal" size="lg" @hide="onClose">
      <b-overlay :show="isLoading" spinner-variant="primary" opacity="1">
        <b-row>
          <b-col>
            <b-form-select
              v-model="selectedProfile"
              :options="profilesOptions"
            ></b-form-select
          ></b-col>
          <b-col
            ><b-button
              variant="primary"
              :disabled="!selectedProfile"
              @click="addProfile"
              >Ajouter</b-button
            ></b-col
          >
        </b-row>

        <b-alert
          variant="warning"
          class="mt-3"
          :show="shouldWarnBeforeRemovingLastTenant"
          ><i class="fas fa-exclamation-triangle"></i> Si vous supprimez
          l'agence de cet utilisateur vous ne serez plus en mesure de
          l'administrer.
        </b-alert>

        <template
          v-if="
            !user._source ||
            !user._source.tenants ||
            !user._source.tenants.length
          "
          ><b-card class="mt-3">
            <b-card-text>
              <h3 class="text-secondary text-center">
                Il n'y a pas d'agence pour cet utilisateur.
              </h3>
            </b-card-text>
          </b-card>
        </template>

        <template v-else>
          <b-card class="mt-3">
            <b-card-text v-if="userTenant">
              <b-badge
                pill
                variant="primary"
                class="tenant-badge mr-2"
                v-for="(profile, key) in userTenant.profiles"
                :key="key"
                >{{ profile }}&nbsp;
                <a
                  class="text-white"
                  href="#"
                  @click="
                    removeProfile(profile, userTenant.name, userTenant.group)
                  "
                  ><i class="fas fa-trash"></i
                ></a>
              </b-badge>
            </b-card-text>
          </b-card>
        </template>
      </b-overlay>
      <template v-slot:modal-header>
        <h2>
          <code>{{ user._source.firstName }} {{ user._source.lastName }}</code>
        </h2>
      </template>
      <template v-slot:modal-footer>
        <b-button
          variant="secondary"
          data-cy="new-tenant-modal-submit-btn"
          @click="onClose"
          >Close</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'userProfilesModal',

  props: {
    user: {
      type: Object,
      required: true,
    },
    selectedTenant: {
      type: Object,
      required: true,
    },
    profiles: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      selectedProfile: null,
    };
  },

  computed: {
    profilesOptions() {
      return [
        { value: null, text: 'Selectionnez un profile' },
        ...this.profiles,
      ];
    },
    userTenant() {
      return this.user._source.tenants.find(
        (el) => el.index === this.selectedTenant.index
      );
    },
    shouldWarnBeforeRemovingLastTenant() {
      if (!this.user || !this.user._source || !this.user._source.tenants) {
        return false;
      }

      return (
        this.user._source.tenants.length === 1 &&
        this.user._source.tenants[0].profiles.length === 1
      );
    },
  },

  methods: {
    addProfile() {
      this.$emit('add-profile', {
        _id: this.user._id,
        profile: this.selectedProfile,
        tenantId: this.selectedTenant._id,
      });
    },
    async removeProfile(profileName, tenantName) {
      if (this.shouldWarnBeforeRemovingLastTenant) {
        const isRemoveConfirmed = await this.$bvModal.msgBoxConfirm(
          `Êtes-vous sûr de vouloir supprimer le dernier tenant de cet utilisateur ?
          Vous ne pourrez plus le gérer.`
        );

        if (!isRemoveConfirmed) {
          return;
        }
      }

      this.$emit('remove-profile', {
        _id: this.user._id,
        profile: profileName,
        tenantName: tenantName,
      });
    },
    onClose() {
      this.selectedProfile = null;
      this.$emit('modal-close');
      this.$bvModal.hide('user-tenants-modal');
    },
  },
};
</script>

<style>
.tenant-badge {
  font-size: 1rem;
}
</style>
